import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-analytics-card',
    templateUrl: './analytics-card.v2.component.html',
    // templateUrl: './analytics-card.component.html',
    styleUrl: './analytics-card.v2.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AnalyticsCardComponent {
  @Input() title!: string;
  @Input() total!: string | number;
  @Input() infoTooltip?: string;
  @Input() items!: {
    label: string;
    value: string | number;
    colorClass?: string;
    tooltip?: string;
  }[];
}
